import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCentricMessageList } from "../../../../../app/redux/slices/app/messageSlice.js";
import { withRouteAccessCheck } from "../../../../../app/Hoc/WithLoginAceessCheck.js";
import { formatDate } from "../../../../utils/utils";
import { deleteSubscriber } from "../../../../../app/redux/slices/app/manageFiberServiceSlice.js";
import ConfirmationDialog from "../../../../components/customComponents/ConfirmationModal/index";
import CustomSnackbar from "../../../../../features/components/customComponents/CustomSnackbar/index";
import { validateForm } from '../../../../../features/components/customComponents/customValidation/index';

const ManageFiberService = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showMessage, setShowMessage] = useState("");
  const dispatch = useDispatch();
  const [showmessageDetails, setShowMessageDetails] = useState(false);
  const [caseId, setcaseId] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [clear, setUploadDocumentModalClear] = useState(false);
  const [confirmObject, setconfirmObject] = useState({});
  const [errorMessages, setErrorMessages] = useState({});
  const [searchFilter, setSearchFilter] = useState({
    address: "",
    email: "",
    phone: "",
    fromDate: formatDate(new Date().setDate(new Date().getDate() - 1000)),
    toDate: formatDate(new Date()),
  });
  const [formData, setFormData] = useState({
    smxDeleteSubscriber: false,
    serviceReferenceNumber: "",

    calixDeleteSubscriber: false,
    subscriberid: "",
    subscriberserviceid: "",

    deleteServiceOnt: false,
    oltId: "",
    ontId: "",
    deleteSubscriber: true,
    jsonResponse:""
  });
  const validationRules = {
    serviceReferenceNumber: { required: formData?.smxDeleteSubscriber ? true : false, name: "Service Reference Number", minDigits:  formData?.smxDeleteSubscriber ? "5" : "0" },

    subscriberid: { required: formData?.calixDeleteSubscriber ? true : false, name: "Subscriber Id",minDigits: formData?.calixDeleteSubscriber ? "5" : "0" },
    subscriberserviceid: { required: formData?.calixDeleteSubscriber ? true : false, name: "Subscriber Service  Id",minDigits: formData?.calixDeleteSubscriber ? "5" : "0" },

    oltId: { required: formData?.deleteServiceOnt ? true : false, name: "OLT Id",minDigits: formData?.deleteServiceOnt ? "5" : "0" },
    ontId: { required: formData?.deleteServiceOnt ? true : false, name: "ONT Id",minDigits: formData?.deleteServiceOnt ? "5" : "0" },

  };

  const CentricUsermessageList = useSelector(
    (state) => state.messageSlice.centricMessageList
  );

  useEffect(() => {
    dispatch(
      getCentricMessageList({
        name: "",
        ...searchFilter,
        page_size: 10,
        page_number: 1,
      })
    );
  }, []);

  const btnSearch = () => {
    dispatch(
      getCentricMessageList({
        name: "",
        ...searchFilter,
        page_size: 100,
        page_number: 1,
      })
    );
  };

  const btnClear = () => {
    setFormData({
      smxDeleteSubscriber: false,
      serviceReferenceNumber: "",

      calixDeleteSubscriber: false,
      subscriberid: "",
      subscriberserviceid: "",

      deleteServiceOnt: false,
      oltId: "",
      ontId: "",
      deleteSubscriber: true,
      jsonResponse:""
    });
  };
  const onValidate = async () => {

    let validationErrors = validateForm(formData, validationRules);
    // const combinedErrors = { ...validationErrors };
    setErrorMessages(validationErrors);
    let noerror = Object.keys(validationErrors)?.length === 0;
    if (noerror) {
      openDialog(formData);
    }
    // else {
    //   setShowMessage("Failed:Please enter the required fields");
    //   setOpenSnackbar(true);
    //   return;
    // }
    return noerror;
  };
  const confirmAction = () => {
    handleRemoveClick();
  };
  const handleRemoveClick = () => {
    dispatch(
      deleteSubscriber({
        subscriberid: formData?.subscriberid || "NA",
        subscriberserviceid: formData?.subscriberserviceid || "NA",
        serviceReferenceNumber: formData?.serviceReferenceNumber || "NA",
        oltId: formData?.oltId,
        ontId: formData?.ontId,
      })
    ).then((res) => {
      if (res?.payload?.data?.["is-success"]) {
        setFormData({ ...formData, jsonResponse: JSON.stringify(res?.payload?.data) })
        setShowMessage("Subscriber deleted successfully.");
        setOpenSnackbar(true);
      } else {
        setShowMessage("Failed to delete subscriber.");
        setOpenSnackbar(true);
      }
    });

    closeDialog();
  };
  const openDialog = (obj) => {
    validateForm()
    setconfirmObject(obj);
    setDialogOpen(true);
  };

  const closeDialog = () => {
    setconfirmObject({});
    setDialogOpen(false);
  };

  return (
    <>
      <ConfirmationDialog
        title="Confirm Action"
        open={dialogOpen}
        onClose={closeDialog}
        onConfirm={confirmAction}
        content="Are you sure you want to delete this subscriber?"
      />
      <CustomSnackbar
        openSnackbar={openSnackbar}
        severity={showMessage.includes("Failed") ? "error" : "success"}
        message={showMessage}
        autoHideDuration={1000}
        handleClose={() => {
          setOpenSnackbar(false);
          if (showMessage.includes("Failed")) {
          } else {
            btnClear();
          }
        }}
      />
      <div className="row min-h-100">
        <div className="col-xxl-12">
          <div className="card card-custom card-xxl-stretch manage-fiber-service">
            <div className="card-body">
              <div className="row">
                <div className="col-lg-4">
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="SMX"
                      checked={formData.smxDeleteSubscriber}
                      onChange={(e) => {
                        const chkd = e.target.checked;

                        setFormData({
                          ...formData,
                          smxDeleteSubscriber: e.target.checked,
                          serviceReferenceNumber: chkd
                            ? formData?.serviceReferenceNumber
                            : "",
                        });
                      }}
                    />
                    <label className="form-check-label" for="SMX">
                      SMX Delete Subscriber
                    </label>
                  </div>
                  <div className="form-group">
                    <label htmlFor="startDate">
                      Service Reference Number
                    </label>

                    <input
                      type="text"
                      disabled={formData?.smxDeleteSubscriber ? false : true}
                      className="form-control"
                      placeholder="Enter Service Reference Number"
                      value={formData.serviceReferenceNumber}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          serviceReferenceNumber: e.target.value,
                        });
                      }}
                    />
                    <div style={{ fontSize: "small", color: "red" }}>
                      {errorMessages.serviceReferenceNumber && (
                        <div style={{ fontSize: 'small', color: 'red' }}> {errorMessages.serviceReferenceNumber}</div>
                      )}
                    </div>

                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="calix"
                      checked={formData.calixDeleteSubscriber}
                      onChange={(e) => {
                        const chkd = e.target.checked;

                        setFormData({
                          ...formData,
                          calixDeleteSubscriber: e.target.checked,
                          subscriberid: chkd ? formData.subscriberid : "",
                          subscriberserviceid: chkd
                            ? formData?.subscriberserviceid
                            : "",
                        });
                      }}
                    />
                    <label className="form-check-label" for="calix">
                      CALIX Delete Subscriber
                    </label>
                  </div>
                  <div className="form-group">
                    <label htmlFor="startDate">Subscriber ID</label>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Subscriber ID"
                      disabled={
                        formData?.calixDeleteSubscriber ? false : true
                      }
                      value={formData.subscriberid}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          subscriberid: e.target.value,
                        });
                      }}
                    />
                    {errorMessages.subscriberid && (
                      <div style={{ fontSize: 'small', color: 'red' }}> {errorMessages.subscriberid}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="startDate">Subscriber Service ID</label>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Subscriber Service ID"
                      disabled={
                        formData?.calixDeleteSubscriber ? false : true
                      }
                      value={formData.subscriberserviceid}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          subscriberserviceid: e.target.value,
                        });
                      }}
                    />
                    {errorMessages.subscriberserviceid && (
                      <div style={{ fontSize: 'small', color: 'red' }}> {errorMessages.subscriberserviceid}</div>
                    )}
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="ont"
                      checked={formData.deleteServiceOnt}
                      onChange={(e) => {
                        const chkd = e.target.checked;

                        setFormData({
                          ...formData,
                          deleteServiceOnt: e.target.checked,
                          oltId: chkd ? formData.oltId : "",
                          ontId: chkd ? formData.ontId : "",
                        });
                      }}
                    />
                    <label className="form-check-label" for="ont">
                      DELETE SERVICE/ONT
                    </label>
                  </div>
                  <div className="form-group">
                    <label htmlFor="startDate">OLT ID</label>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter OLT ID"
                      disabled={formData?.deleteServiceOnt ? false : true}
                      value={formData.oltId}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          oltId: e.target.value,
                        });
                      }}
                    />
                    {errorMessages.oltId && (
                      <div style={{ fontSize: 'small', color: 'red' }}> {errorMessages.oltId}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="startDate">ONT ID</label>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter ONT ID"
                      disabled={formData?.deleteServiceOnt ? false : true}
                      value={formData.ontId}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          ontId: e.target.value,
                        });
                      }}
                    />
                    {errorMessages.ontId && (
                      <div style={{ fontSize: 'small', color: 'red' }}> {errorMessages.ontId}</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12 text-center">
                  <button
                    className="btn btn-custom btn-danger px-5"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      onValidate()

                    }}
                    disabled={formData?.smxDeleteSubscriber === false && formData?.calixDeleteSubscriber === false && formData?.deleteServiceOnt === false}
                  >
                    Delete
                  </button>
                </div>
              </div>
                  <div className="form-group">
                <label htmlFor="#resp">
                  JSON response 
                </label>
                <textarea
                  className="form-control"
                  id="resp"
                  placeholder=""
                  rows="5"
                  value={formData.jsonResponse || ""}
                  disabled
                ></textarea></div>
            </div>
         
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouteAccessCheck(ManageFiberService);
